export class Signal<T> {
    private _connections: SignalConnection<T>[] = [];
    private _nextConnectionId = 0;

    connect(handler: SignalHandler<T>): number {
        let connection = new SignalConnection(this._nextConnectionId++, handler);
        this._connections.push(connection);
        return connection.connectionId;
    }

    disconnect(connectionId: number): boolean {
        let index = 0;
        for (let connection of this._connections) {
            if (connection.connectionId == connectionId) {
                this._connections.splice(index, 1);
                return true;
            }
            index++;
        }
        return false;
    }

    emit(event?: T) {
        let connections = this._connections.slice();
        for (let connection of connections) {
            connection.handler(event as T);
        }
    }
}

class SignalConnection<T> {
    constructor(public connectionId: number, public handler: SignalHandler<T>) {
    }
}

type SignalHandler<T> = (event: T) => void;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/signal.ts